export default __webpack_public_path__ + "static/media/home-background.968bfacf.svg";